import React, { useState, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { format, isAfter, isToday, startOfToday } from 'date-fns';
import { IconButton } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import Container from './styles/Container';
import DatesWrapper from './styles/DatesWrapper';
import DateButton from './styles/DateButton';
import ButtonCaptionText from './styles/ButtonCaptionText';

function DatesList({ onDateClick, data }) {
  const pageSize = 10;
  const today = startOfToday();

  const todayIndex = data.findIndex((d) => isToday(d.date));

  // чтобы текущая дата была по центру, если она есть в списке
  const initialOffset = useMemo(() => {
    if (todayIndex === -1) return 0;
    return Math.max(0, todayIndex - 5);
  }, [todayIndex]);

  const [offset, setOffset] = useState(initialOffset);

  useEffect(() => {
    setOffset(initialOffset);
  }, [initialOffset]);

  const currentItems = data.slice(offset, offset + pageSize);

  const canGoPrev = offset > 0;
  const canGoNext = offset + pageSize < data.length;

  return (
    <Container>
      <IconButton color="primary" disabled={!canGoPrev} onClick={() => setOffset((p) => Math.max(0, p - 1))}>
        <ChevronLeft />
      </IconButton>

      <DatesWrapper>
        {currentItems.map((item) => (
          <DateButton
            key={item.date.toISOString()}
            variant="outlined"
            isFuture={isAfter(item.date, today)}
            isToday={isToday(item.date)}
            onClick={() => onDateClick(item)}
          >
            {format(item.date, 'dd.MM')}
            <br />
            <ButtonCaptionText>
              {`${Number(item.totalProduct.plan?.toFixed(2)) || '-'} / ${Number(item.totalProduct.fact?.toFixed(2)) || '-'}`}
            </ButtonCaptionText>
          </DateButton>
        ))}
      </DatesWrapper>

      <IconButton
        color="primary"
        disabled={!canGoNext}
        onClick={() => setOffset((p) => Math.min(data.length - pageSize, p + 1))}
      >
        <ChevronRight />
      </IconButton>
    </Container>
  );
}

DatesList.propTypes = {
  onDateClick: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default DatesList;
